const SCRIPT_ID = "google-recaptcha-script";
const ONLOAD_CALLBACK = "__onboardingRecaptchaLoaded";
const SCRIPT_URL =
  `https://www.google.com/recaptcha/api.js?render=explicit&hl=pt-BR&onload=${ONLOAD_CALLBACK}`;

let scriptPromise = null;

export function loadRecaptchaScript(
  targetDocument = document,
  targetWindow = window,
) {
  if (targetWindow.grecaptcha) {
    return Promise.resolve(targetWindow.grecaptcha);
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    let script = targetDocument.getElementById(SCRIPT_ID);
    let settled = false;

    const cleanupCallback = () => {
      if (targetWindow[ONLOAD_CALLBACK] === handleReady) {
        delete targetWindow[ONLOAD_CALLBACK];
      }
    };

    const handleReady = () => {
      if (settled || !targetWindow.grecaptcha) return;

      settled = true;
      cleanupCallback();
      resolve(targetWindow.grecaptcha);
    };

    const handleError = () => {
      if (settled) return;

      settled = true;
      scriptPromise = null;
      cleanupCallback();
      script?.remove();
      reject(new Error("Não foi possível carregar o reCAPTCHA."));
    };

    targetWindow[ONLOAD_CALLBACK] = handleReady;

    const isNewScript = !script;
    if (isNewScript) {
      script = targetDocument.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_URL;
      script.async = true;
      script.defer = true;
    }

    script.addEventListener("error", handleError, { once: true });

    if (isNewScript) {
      targetDocument.head.appendChild(script);
    }
  });

  return scriptPromise;
}
